"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCibliErrorFromAxios = buildCibliErrorFromAxios;
const cibli_error_1 = require("../errors/cibli.error");
/**
 * Build a CibliError from an Axios error using a translate function.
 * Supports both code and message from response data for translation key lookup.
 */
function buildCibliErrorFromAxios(error, translate) {
    var _a;
    const data = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data;
    if (data) {
        const errorCode = data.code;
        const errorKey = errorCode !== null && errorCode !== void 0 ? errorCode : data.message;
        if (errorKey) {
            const translationKey = `errors.${errorKey}`;
            const translatedMessage = translate(translationKey);
            const finalMessage = translatedMessage !== translationKey
                ? translatedMessage
                : translate('errors.internal_error');
            return new cibli_error_1.CibliError(finalMessage, errorCode);
        }
    }
    return new cibli_error_1.CibliError(translate('errors.internal_error'));
}
